import type { Options } from "../../types/options";
import type { ExtendedExtract } from "types/extendedExtract";

type EventId = string;
type Key = ExtendedExtract<
  Options["featureName"],
  | "[テスト以外には使わない] eventIdが引数にある時の テストの featureName"
  | "polling"
  | "newEventTicketPage"
  | "vspoExclusive"
  | "multiAngle"
>;
type FeatureNameEventIdMapType = {
  [K in Key]: EventId[];
};

// featureName に依存するハードコーディングを Options の増減に合わせて対応するため、型で縛る
// 特に feature flag から機能除却時の削除漏れ対策
const FEATURE_NAME_EVENT_ID_MAP_BASE: FeatureNameEventIdMapType = {
  "[テスト以外には使わない] eventIdが引数にある時の テストの featureName": [
    "test-event-id",
  ],
  polling: [
    // prod環境
    // ストファイ
    "evt_251213-SFL2025POGF",
    // テスト環境1
    "evt_kP5C3U85hVABL23tcQTM",
    // テスト環境2
    "evt_z3RJ1xafbVJfg1s8n4oj",
    // テスト環境3
    "evt_zhOP3ynj5u2X1BPb5zz1",
    // ReGLOSS
    "evt_25121601-jpregloss1st",
    // IVSプレイヤーテストページ
    "evt_5oZ6aJRE7dwg4YHmn8Em",
    // きゅるるん
    "evt_26011701-jpholo3rdgenlive",
    "evt_26011702-engholo3rdgenlive",
    // すいせい
    "evt_26022101-jpsuiseilive",
    "evt_26022102-engsuiseilive",
    // hololive 7th fes
    "evt_26030601-jphololive7thfes",
    "evt_26030602-enghololive7thfes",
    // dev環境
    // コメント挙動確認
    "evt_OTSdn5k3Y4izkU6NH7PR",
  ],
  newEventTicketPage: [
    // dev環境
    "evt_OTSdn5k3Y4izkU6NH7PR",
    // vspo
    "evt_ZdlNpSceJPswQKdIikOE",
  ],
  vspoExclusive: ["evt_ZdlNpSceJPswQKdIikOE"],
  multiAngle: ["evt_ZdlNpSceJPswQKdIikOE"],
};

// featureName の増減に合わせて処理を変更させないため、 Record<string, string[]> に upcast しておく
const FEATURE_NAME_EVENT_ID_MAP = Object.fromEntries<EventId[]>(
  Object.entries(FEATURE_NAME_EVENT_ID_MAP_BASE)
);

export const isAllowedByEventId = (
  eventId: EventId,
  featureName: string
): boolean => {
  const allowedEventIds = FEATURE_NAME_EVENT_ID_MAP[featureName];
  if (allowedEventIds === undefined) return false;
  return allowedEventIds.includes(eventId);
};
